<template>
  <el-dialog :visible="visible" class="overflow-hidden" top="0" :before-close="handleClose">
    <div class="">
      <div class="content text-center mb-10">
        <img class="mt-8" src="@/assets/images/dialog_true.png" alt />
        <p class="font-bold text-xl text-black my-5">{{ $t('promotion.fundsGrowthPromotion.success') }}</p>
        <i18n path="promotion.fundsGrowthPromotion.optInSuccessMsg" tag="span" class="text-grayG4 leading-6">
          <template v-slot:tnc>
            <a :href="tncLink" target="_blank">{{ $t('promotion.fundsGrowthPromotion.tnc') }}</a>
          </template>
        </i18n>
      </div>
      <div slot="footer" class="mb-10">
        <span class="dialog-footer">
          <el-button
            class="blue_button fgp_blue_button disabled:border-[#cdcfd3]! disabled:bg-transparent!"
            @click="handleClose"
          >
            {{ $t('common.button.confirm') }}
          </el-button>
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CongratulationModal',
  props: {
    congratulationModalVisible: Boolean,
    tncLink: String
  },
  data() {
    return {
      visible: false
    };
  },
  watch: {
    congratulationModalVisible(bool) {
      this.visible = bool;
    },
    visible(bool) {
      this.$emit('update:congratulationModalVisible', bool);
    }
  },
  methods: {
    handleClose() {
      this.visible = !this.visible;
      location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/fundsGrowthPromotion.scss';
</style>
